import { Link } from '@chakra-ui/react';
import { SoftLink } from '../../../../components/soft-link/SoftLink';

export interface ProductLinkTypes {
    c_pwaUrl?: string;
    isSoftLink?: boolean;
    children: React.ReactNode;
    disableLink?: boolean;
}
export const ProductLink = ({
    c_pwaUrl,
    isSoftLink,
    children,
    disableLink,
}: ProductLinkTypes): JSX.Element => {
    if (disableLink) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <>{children}</>;
    }

    if (c_pwaUrl) {
        if (isSoftLink) {
            return <SoftLink to={c_pwaUrl}>{children}</SoftLink>;
        }

        return (
            <Link _hover={{ textDecoration: 'none' }} data-testid="chakra-link" href={c_pwaUrl}>
                {children}
            </Link>
        );
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
};

ProductLink.defaultProps = {
    c_pwaUrl: '',
    isSoftLink: false,
    disableLink: false,
};
